import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";

import IconPersonal from "../../assets/img/new/personal.png";
import IconOrganization from "../../assets/img/new/group.png";

import { useHistory } from "react-router";
import { connect, useDispatch } from "react-redux";
import { makeGetDataAccount } from "../../lib/selector";
import { setDataAccount } from "../client/actions";

function PageTypeAccount({ dataAccount }) {
  const history = useHistory();
  const dispatch = useDispatch();

  const [type, setType] = useState("");

  useEffect(() => {
    if (!dataAccount) {
      history.push("/open-account/check-info");
      return;
    }
  }, []);

  function setTypeAccount(params) {
    let _data = Object.assign({}, dataAccount);
    _data.C_TYPE = params;
    dispatch(setDataAccount(_data));

    setType(params);

    return;
  }

  function _handleClickNext() {
    if (!type) return;

    switch (type) {
      case "personal":
        history.push("/open-account/personal");
        break;

      case "business":
        history.push("/open-account/organization");
        break;

      default:
        break;
    }
  }

  return (
    <>
      <Container>
        <Row>
          <Col lg="8" className="offset-lg-2">
            <div className="content pt180 px-4">
              <h2>Chọn loại tài khoản</h2>
              <div className="account-category">
                <div className="d-flex flex-column">
                  <a
                    className={
                      "account-type personal mx-3 " +
                      (type === "personal" ? "active" : "")
                    }
                    onClick={() => setTypeAccount("personal")}
                  >
                    <span className="account-icon">
                      <img src={IconPersonal} alt=""/>
                      {/* <img src={Personal} alt="" /> */}
                    </span>
                  </a>
                  <p className="text-center fz-20" style={{color: '#085DDA'}}>Cá nhân</p>
                </div>
                <div className="d-flex flex-column">
                  <a
                    className={
                      "account-type business mx-3 " +
                      (type === "business" ? "active" : "")
                    }
                    onClick={() => setTypeAccount("business")}
                  >
                    <span className="account-icon">
                      <img src={IconOrganization} alt=""/>
                      {/* <img src={Bussiness} alt="" /> */}
                    </span>
                  </a>
                  <p className="text-center fz-20" style={{color: '#085DDA'}}>Tổ chức</p>
                </div>
              </div>

              <p className="text-center mb-5">
                <Button
                  className="btn-next"
                  onClick={_handleClickNext}
                  style={{ width: "375px" }}
                >
                  TIẾP TỤC
                </Button>
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}

const mapStateToProps = (state) => {
  const getDataAccount = makeGetDataAccount();

  return {
    dataAccount: getDataAccount(state),
  };
};

export default connect(mapStateToProps)(PageTypeAccount);
